import React, { Component } from 'react';
import { Table, Column, Cell } from 'components/Table';
import { Link } from 'react-router';
import Score from 'components/Score';

import { openModal } from 'actions/modal';
import { firebaseConnect, helpers } from 'react-redux-firebase';

import LaunchIcon from 'assets/icons/launch';
import PencilIcon from 'assets/icons/pencil';
import './metrics.scss';
import '../../../sass/components/ui-list';

import { keyedObjToArr } from '../../util/index';
import { calcPQLessonAverage } from '../../util/metrics';
import InlineSVG from 'svg-inline-react';


export class NameCell extends Component{
    render(){
        return(
            <Cell>
                <Link to={{
                    pathname: `/studentmetrics/${this.props.classroom.id}/${this.props.item.id}`
                }}>
                    <span className="student-name">{this.props.item.name}</span>
                    <InlineSVG src={LaunchIcon} element="span" className="icon" />
                </Link>
            </Cell>
        );
    }
}

export class CurrentLessonCell extends Component{
    render (){
        let lesson = this.props.item.lesson;
        let activity = this.props.item.activity;
        let text = `${lesson}, ${activity}`;
        if(!lesson && !activity)
            text = '--';

        return (
            <Cell>{text}</Cell>
        );
    }
}

export class OverallAverageCell extends Component{
    render (){
        let sumTotal = 0;
        let divisor = 0;
        let overallAverage = 0;
        let hasMetrics = false;

        if(this.props.item.metrics){
            hasMetrics = true;
            keyedObjToArr(this.props.item.metrics).forEach((lesson) => {
                let lessonAverage = calcPQLessonAverage(lesson);
                if (lessonAverage){
                    sumTotal += lessonAverage;
                    divisor += 1;
                }
            }, this);

            overallAverage = Math.round(sumTotal / divisor);
            hasMetrics = !isNaN(overallAverage);
        }

        return (
            <Cell>
                {hasMetrics ?
                    (
                        <Score
                            value={overallAverage}
                            text={`${overallAverage} %`}
                            boxClass="metrics-box-color"
                        />)
                    : (
                        <span>
                          --
                      </span>
                    )}

            </Cell>
        );
    }
}

export class OverviewCell extends Component{
    render (){
        return (
            <Cell>
                <span className="button notes-button"
                      onClick={this.props.notes.bind(this, this.props.item)}
                >
                    <span className="notes-icon">
                        <InlineSVG src={PencilIcon} element="span" className="icon" />
                    </span>
                    <span className="notes-label">
                        Notes
                    </span>
                </span>
                <span>&nbsp;</span>
                <span className="button overview-button"
                      onClick={this.props.overview.bind(this, this.props.item)}>
                    Overview
                </span>
            </Cell>
        );
    }
}


// WEBPACK FOOTER //
// ./js/components/Metrics/MetricsCells.js